const Fibryga = ({ themeColor }: { themeColor: string }) => {
  return (
    <>
      <div className="mx-auto pb-10">
        <div className="text-xl md:text-3xl font-bold text-[#000000]">
          <span style={{ color: themeColor }}> MEDICAL BENEFITS BILLING PORTAL FOR PROVIDERS.</span>
          <p className="my-2">SITE-OF-CARE DRIVEN COPAY ASSISTANCE.</p>
        </div>

        <p className="my-2">
          If you need copay assistance for your patient please visit The Fibryga Copay Assistance
          Portal For Providers by clicking the button below. Eligible patients can receive up to a
          maximum of $2,500 per enrollment for copay assistance associated with the cost of Fibryga.
          Enrollment can be renewed at Octapharma's discretion up to 3 times within a calendar year.
        </p>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            The patient must be receiving treatment with Fibryga or have a prescription to begin
            treatment.
          </li>
          <li>The patient must have commercial insurance.</li>
          <li>
            Patient must use Fibryga® for the FDA-approved indication of treatment of acute
            bleeding episodes in adults and children with congenital fibrinogen deficiency,
            including afibrinogenemia and hypofibrinogenemia, with a diagnosis code of D68.2{' '}
          </li>
        </ul>
        <p className="mb-4">
          Note: Diagnosis codes are provided for reference only. Selection and documentation of an
          appropriate diagnosis code are the responsibility of the patient's health care provider.
        </p>

        <div className="font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state
            government health insurance are not eligible.
          </li>
          <li>
            The Copay Assistance Program does not cover costs associated with administration of
            therapy, such as office visits, infusion costs, or other professional services.
          </li>
        </ul>
      </div>
    </>
  );
};

export default Fibryga;
